export const LOGOS = [
  {
    image: '/images/modules/site/home24/logos/shopify.svg',
    alt: 'Shopify’s logo',
    height: '40px',
  },
  {
    image: '/images/modules/site/home24/logos/ey.svg',
    alt: 'EY’s logo',
    height: '50px',
  },
  {
    image: '/images/modules/site/home24/logos/figma.svg',
    alt: 'Figma’s logo',
    height: '44px',
  },
  {
    image: '/images/modules/site/home24/logos/duolingo.svg',
    alt: 'Duolingo’s logo',
    height: '38px',
  },
  {
    image: '/images/modules/site/home24/logos/newyorktimes.svg',
    alt: 'New York Times’s logo',
    height: '34px',
  },
  {
    image: '/images/modules/site/home24/logos/mercado-libre.svg',
    alt: 'Mercado Libre’s logo',
    height: '40px',
  },
  {
    image: '/images/modules/site/home24/logos/american-airlines.svg',
    alt: 'American Airlines’s logo',
    height: '36px',
  },
  {
    image: '/images/modules/site/home24/logos/ford.svg',
    alt: 'Ford’s logo',
    height: '42px',
  },
  {
    image: '/images/modules/site/home24/logos/mercedes.svg',
    alt: 'Mercedes Benz’s logo',
    height: '52px',
  },
  {
    image: '/images/modules/site/home24/logos/societe-generale.svg',
    alt: 'Société Générale’s logo',
    height: '36px',
  },
  {
    image: '/images/modules/site/home24/logos/vodafone.svg',
    alt: 'Vodafone’s logo',
    height: '48px',
  },
  {
    image: '/images/modules/site/home24/logos/philips.svg',
    alt: 'Philips’s logo',
    height: '36px',
  },
  {
    image: '/images/modules/site/home24/logos/sap.svg',
    alt: 'SAP’s logo',
    height: '50px',
  },
  {
    image: '/images/modules/site/home24/logos/infosys.svg',
    alt: 'Infosys’s logo',
    height: '40px',
  },
  {
    image: '/images/modules/site/home24/logos/spotify.svg',
    alt: 'Spotify’s logo',
    height: '46px',
  },
]
